import { ProjectOrdersTab } from '~/subdomains/OrdersOverview/Orders/OrderedProjects/ProjectOrdersTab';
import { PriolistTab } from '~/subdomains/OrdersOverview/Orders/PriolistTab';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';

export function Orders() {
  const t = useTranslate();
  return (
    <Tabs mt={3} isLazy>
      <TabList>
        <Tab>{t('orders.projectorders.heading')}</Tab>
        <Tab>{t('orders.priolist.heading')}</Tab>
      </TabList>
      <TabPanels>
        <TabPanel>
          <ProjectOrdersTab />
        </TabPanel>
        <TabPanel>
          <PriolistTab />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
}
